import { useState } from 'react';
import { Table } from '@humanforce/mango-ui-react';
import { getRegionInfo } from '../organisationFixtures';
import type { OrgData } from '../organisationFixtures';

interface LocationsTabProps {
  orgId: string;
  orgData: OrgData;
}

interface LocationRow {
  name: string;
  code: string;
  region: string;
  country: string;
  state: string;
  city: string;
  phol: string;
}

const columns = [
  { field: 'name', header: 'Payroll name', sortable: true },
  { field: 'code', header: 'Code', sortable: true },
  { field: 'region', header: 'Region', sortable: true },
  { field: 'country', header: 'Country', sortable: true },
  { field: 'state', header: 'State', sortable: true },
  { field: 'city', header: 'City', sortable: true },
  { field: 'phol', header: 'Public holidays schedule', sortable: true },
];

export const LocationsTab = ({ orgData }: LocationsTabProps) => {
  const [selected, setSelected] = useState<LocationRow[]>([]);

  const rows: LocationRow[] = orgData.businessRecords.flatMap((br) =>
    br.payrolls.map((p) => {
      const info = getRegionInfo(p.region);
      return { name: p.name, code: p.code, region: p.region, country: info.country, state: info.state, city: info.city, phol: info.phol };
    })
  );

  return (
    <div className="mgo-stack mgo-gap-l">
      <Table
        value={rows}
        columns={columns}
        selectable
        selection={selected}
        onSelectionChange={(sel) => setSelected(Array.isArray(sel) ? sel as LocationRow[] : [sel as LocationRow])}
      />
    </div>
  );
};
